import Platforms from "./Platforms";
export default Platforms;